import { render, staticRenderFns } from "./Toogle2.vue?vue&type=template&id=72afbf54&scoped=true&lang=pug&"
import script from "./Toogle2.vue?vue&type=script&lang=js&"
export * from "./Toogle2.vue?vue&type=script&lang=js&"
import style0 from "./Toogle2.vue?vue&type=style&index=0&id=72afbf54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72afbf54",
  null
  
)

export default component.exports